import { render, staticRenderFns } from "./LayoutMeasureItem.vue?vue&type=template&id=42b23ade&scoped=true"
import script from "./LayoutMeasureItem.vue?vue&type=script&lang=js"
export * from "./LayoutMeasureItem.vue?vue&type=script&lang=js"
import style0 from "./LayoutMeasureItem.vue?vue&type=style&index=0&id=42b23ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b23ade",
  null
  
)

export default component.exports